/** Волна — графический приём айдентики ANTÉ (README §Волна, путь дословно).
 *  Ставится последним элементом синей шапки. */
export function Wave() {
  return (
    <svg className="wave" viewBox="0 0 300 13" fill="none" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M2 8 C40 3 70 3 108 7 C150 12 188 12 226 6 C258 3 282 4 298 7"
        stroke="#fff"
        strokeOpacity=".5"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Та же волна в синем (24×15) — иконка новости в ленте. */
export function WaveIcon() {
  return (
    <svg className="news-wave" viewBox="0 0 24 15" fill="none" aria-hidden="true">
      <path
        d="M2 9.5 C5 5.5 8 5.5 11 8.5 C14 11.5 18 11.5 22 6.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
